export const categories = [
  {
    id: 'お知らせ',
    name: 'お知らせ',
  },
  {
    id: 'アップデート',
    name: 'アップデート',
  },
  {
    id: 'マニュアル',
    name: 'マニュアル',
  },
  {
    id: 'その他',
    name: 'その他',
  },
]

export const publishStatuses = [
  {
    id: '公開',
    name: '公開',
  },
  {
    id: '下書保存',
    name: '下書保存',
  },
  {
    id: '非公開',
    name: '非公開',
  },
]

export const isOpenStatuses = [
  {
    id: 'すべて',
    name: 'すべて',
  },
  {
    id: '未読',
    name: '未読',
  },
  {
    id: '既読',
    name: '既読',
  },
]

// スプレッド構文を使用して新しい配列を生成
export const publishStatusesAll = [
  {
    id: 'すべて',
    name: 'すべて',
  },
  ...publishStatuses,
]
export const categoriesAll = [
  {
    id: 'すべて',
    name: 'すべて',
  },
  ...categories,
]
